/* jshint node:true */
'use strict';

var React               = require('react');
var Advert              = require('../../common/Advert.jsx');
var AdReloaderMixin     = require('../../../mixins/AdReloaderMixin.js');
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var ReportPreview       = require('./article/index.jsx');

var TabReport = React.createClass({

    displayName: 'TabReport',

    mixins : [ AdReloaderMixin ],

    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    render: function () {

        var oStore          = this.props.store;
        var leagueName      = oStore.getLeagueName();
        var aLeagueTable    = oStore.getLeagueTable();
        var newsList        = oStore.getNewsList();
        var Article         = oStore.getArticle();

        var state = '';

        return (
            <div className="main-content react-content">
                <div id="gamepackage-wrap">
                    <div id="gamepackage-content-wrap" className="layout-bc">
                        <section id="article-feed" className="col-b" data-behavior="author_overlay article_header_news_feed_item_meta social_tools comment">
                            <ReportPreview article={Article} />
                        </section>
                        <section className="col-c">
                            <article className="ad-300" key="mpuadvert">
                                <div className="ad-center">
                                    <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                                </div>
                            </article>
                            <LeagueTable key="table" tableHref={this.props.tableHref} date="" name={leagueName} table={aLeagueTable} />
                            <NewsList key="news" header={newsList.header} link={newsList.link} articles={newsList.articles} />
                        </section>
                    </div>
                </div>
            </div>
        );

    }

});

module.exports = TabReport;




/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabArticle.jsx
 **/